const spanishPaths = require('../locales/es/urls');
const englishPaths = require('../locales/en/urls');

const spanishToEnglishPaths = Object.keys(spanishPaths).map((path) => [
  spanishPaths[path],
  englishPaths[path],
]);
const englishToSpanishPaths = Object.keys(englishPaths).map((path) => [
  englishPaths[path],
  spanishPaths[path],
]);

const spanishToEnglishUrls = new Map([
  // ['/courses/4-semanas-160-horas-curso-tefl', '/courses/one-month-160-hour-tefl-course'],
  ...spanishToEnglishPaths,
]);

const englishToSpanishUrls = new Map([
  // ['/courses/one-month-160-hour-tefl-course', '/courses/4-semanas-160-horas-curso-tefl'],
  ...englishToSpanishPaths,
]);

module.exports = { spanishToEnglishUrls, englishToSpanishUrls };
